(function () {
  var scheduled = false;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      remediate();
    });
  }

  function removeInvalidAriaControls(root) {
    root
      .querySelectorAll(
        '.Meteor-DesktopNavigation[aria-controls], .Meteor-MobileNavigation[aria-controls], #meteor-desktop-nav[aria-controls], #meteor-mobile-nav[aria-controls], .Meteor-DesktopNavigation [aria-controls], .Meteor-MobileNavigation [aria-controls], #meteor-desktop-nav [aria-controls], #meteor-mobile-nav [aria-controls]'
      )
      .forEach(function (element) {
      var controls = element.getAttribute('aria-controls');
      if (controls && !document.getElementById(controls)) {
        element.removeAttribute('aria-controls');
      }
      });
  }

  function normalizeMeteorNavigation(root) {
    root
      .querySelectorAll(
        '.Meteor-DesktopNavigation[role], .Meteor-MobileNavigation[role], #meteor-desktop-nav[role], #meteor-mobile-nav[role], .Meteor-DesktopNavigation [role], .Meteor-MobileNavigation [role], #meteor-desktop-nav [role], #meteor-mobile-nav [role]'
      )
      .forEach(function (element) {
        var role = element.getAttribute('role');
        if (role === 'menubar' || role === 'menuitem' || role === 'none' || role === 'menu') {
          element.removeAttribute('role');
        }
      });

    root
      .querySelectorAll(
        '.Meteor-DesktopNavigation [aria-expanded], .Meteor-MobileNavigation [aria-expanded], #meteor-desktop-nav [aria-expanded], #meteor-mobile-nav [aria-expanded]'
      )
      .forEach(function (element) {
        if (!element.matches('a, button, summary, [tabindex]:not([tabindex="-1"])')) {
          element.removeAttribute('aria-expanded');
        }
      });
  }

  function hidePageFlyCompactInputs(root) {
    root.querySelectorAll('input[type="checkbox"][id^="compact-"]').forEach(function (input) {
      if (input.getAttribute('tabindex') !== '-1') {
        input.setAttribute('tabindex', '-1');
      }
      if (input.getAttribute('aria-hidden') !== 'true') {
        input.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function improveKlaviyoButtonLabels(root) {
    root.querySelectorAll('button[aria-label="Button"], [role="button"][aria-label="Button"]').forEach(function (button) {
      var image = button.querySelector('img[alt]');
      var alt = image ? image.getAttribute('alt').trim() : '';
      if (alt) {
        button.setAttribute('aria-label', 'Select: ' + alt);
      }
    });
  }

  function normalizeJudgeMeSummaryStars(root) {
    root.querySelectorAll('.jdgm-rev-widg__summary-stars[role="img"]').forEach(function (stars) {
      var link = stars.querySelector('a[href]');
      if (!link) return;

      var ratingLabel = stars.getAttribute('aria-label') || link.textContent || '';
      ratingLabel = ratingLabel.replace(/\s+/g, ' ').trim();
      stars.removeAttribute('role');
      stars.removeAttribute('aria-label');

      if (ratingLabel && !link.getAttribute('aria-label')) {
        link.setAttribute('aria-label', ratingLabel + ' - Judge.me reviews');
      }
    });
  }

  var altByFilename = {
    'Pupford_Illustration_Calm_MacnCheese_RGB_1.webp': 'Pupford calming supplement illustration',
    'Pupford_Illustration_UI_PupApproved_RGB_1_1.webp': 'Pupford pup-approved supplement illustration',
    'Pupford_Illustration_Immunity_PB_J_RGB_1.webp': 'Pupford immunity supplement illustration',
    'Pupford_Illustration_Cognition_Beef_RGB_1.webp': 'Pupford cognition supplement illustration',
    'Pupford_product_toys_tornado-4_-_359_x_405.jpg': 'Pupford Tornado puzzle toy',
    'Dogs_Lined_Up_1_1.png': 'Dogs lined up for Pupford training',
    'Play_Bowing_1_1.png': 'Dog play bowing illustration',
    'smart_logo.webp': 'PetSmart',
    'Petco-Logo-2011.png': 'Petco',
    'Minimal_odor_16.png': 'Minimal odor icon',
  };

  var decorativeFilenames = [
    'ChatGPT_Image_Dec_31__2025__06_29_03_PM-removebg-preview.png',
    'ChatGPT_Image_Dec_31__2025__06_40_25_PM-removebg-preview.png',
    'ChatGPT_Image_Dec_31__2025__06_38_55_PM-removebg-preview.png',
    'ChatGPT_Image_Dec_31__2025__06_27_44_PM-removebg-preview.png',
    'Your_paragraph_text_24.png',
    'Group_5_1.png',
    'Group_5_1.webp',
    'Group_7_52101ee9-30a5-41b9-8a11-42280887a448.png',
    'Group_6.png',
    'Group_5.png',
    'star.png',
  ];

  function filenameFromUrl(url) {
    if (!url) return '';
    return url.split('?')[0].split('/').pop() || '';
  }

  function normalizeFileLabel(value) {
    return (value || '')
      .split('__PID:')[0]
      .replace(/\.(png|jpe?g|webp|gif|svg)$/i, '')
      .replace(/[_-]+/g, ' ')
      .replace(/\s*\(\d+\)\s*/g, ' ')
      .replace(/\b\d+\s*x\s*\d+\b/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function updateImageAlt(image, nextAlt) {
    if (image.getAttribute('alt') !== nextAlt) {
      image.setAttribute('alt', nextAlt);
    }
  }

  function remediateImageAltText(root) {
    root.querySelectorAll('img').forEach(function (image) {
      var src = image.currentSrc || image.getAttribute('src') || '';
      var filename = filenameFromUrl(src);
      var alt = image.getAttribute('alt') || '';
      var altFilename = filenameFromUrl(alt.split('__PID:')[0]);
      var lookupFilename = filename || altFilename;

      if (lookupFilename === 'collection-home.png') {
        updateImageAlt(image, '');
        return;
      }

      if (Object.prototype.hasOwnProperty.call(altByFilename, lookupFilename)) {
        updateImageAlt(image, altByFilename[lookupFilename]);
        return;
      }

      if (decorativeFilenames.indexOf(lookupFilename) !== -1 || /^Rectangle_\d/i.test(lookupFilename)) {
        updateImageAlt(image, '');
        return;
      }

      if (/__PID:|\.(png|jpe?g|webp|gif|svg)(?:$|__PID:)/i.test(alt)) {
        updateImageAlt(image, normalizeFileLabel(alt));
      }
    });
  }

  function remediate(root) {
    root = root || document;
    normalizeMeteorNavigation(root);
    removeInvalidAriaControls(root);
    hidePageFlyCompactInputs(root);
    improveKlaviyoButtonLabels(root);
    normalizeJudgeMeSummaryStars(root);
    remediateImageAltText(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      remediate();
      observe();
    });
  } else {
    remediate();
    observe();
  }

  function observe() {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['role', 'aria-controls', 'aria-expanded', 'aria-label', 'alt', 'src', 'srcset'],
    });
  }
})();
